export default __webpack_public_path__ + "static/media/reportsOff.81514df3.svg";